import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function EmailForm() {
  const formRef = useScrollAnimation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('email', email.trim());
      const res = await fetch('https://readdy.ai/api/form/d6kppoc6fojmejgaiocg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="py-14 sm:py-16" style={{ background: '#f9f6ef' }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={formRef} className="animate-scale-up rounded-2xl p-8 sm:p-10 text-center shadow-sm" style={{ background: '#ffffff', border: '1px solid #f0e0b0' }}>
          <div className="w-12 h-12 flex items-center justify-center rounded-full mx-auto mb-5"
            style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)' }}>
            <i className="ri-mail-send-line text-xl" style={{ color: '#000000' }}></i>
          </div>
          <h3 className="text-xl sm:text-2xl font-bold mb-3" style={{ color: '#000000' }}>Get the Legacy Annual Review</h3>

          {submitted ? (
            <div className="py-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full mx-auto mb-4"
                style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)' }}>
                <i className="ri-check-line text-2xl text-black"></i>
              </div>
              <p className="text-sm font-semibold mb-1" style={{ color: '#000000' }}>You're all set!</p>
              <p className="text-sm" style={{ color: '#666666' }}>
                The Legacy Annual Review is on its way to your inbox. If you don't see it within a few minutes, check your Promotions or Junk folder.
              </p>
            </div>
          ) : (
            <>
              <p className="text-sm mb-2" style={{ color: '#666666' }}>
                Enter your email below and receive the review instantly.
              </p>
              <p className="text-sm mb-8" style={{ color: '#888888' }}>
                Don&apos;t see it? Check your Promotions or Junk folder.
              </p>
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="max-w-md mx-auto"
              >
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Your email address"
                    className="flex-1 px-4 py-3 rounded-lg focus:outline-none text-sm"
                    style={{ background: '#fafafa', border: '1px solid #d4b86a', color: '#333333' }}
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="px-6 py-3 font-bold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
                    style={{ background: submitting ? '#aaa' : 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
                  >
                    {submitting ? 'Sending...' : 'Send Me the Review'}
                  </button>
                </div>
                {error && (
                  <p className="text-xs mt-2 text-center" style={{ color: '#C8102E' }}>{error}</p>
                )}
              </form>
            </>
          )}
        </div>
      </div>
    </section>
  );
}